const dataLayerUtils = require('@dc/data-layer/src/utils.js');

/**
 * fire _satellite event
 * @param {array} competitorsTable
 * @param {boolean} exclusive
 */
function pricePromiseAnalytics(competitorsTable, exclusive) {
  competitorsTable = exclusive ? [] : competitorsTable.sort((a, b) => a.price - b.price);

  const analyticsData = {
    pricePromise: {
      priceMessageType: 'noprice',
      isCurryesCheapest: undefined,
      priceTableData: undefined
    }
  };
  if (exclusive) {
    analyticsData.pricePromise.priceMessageType = 'exclusive';
  } else if (competitorsTable.length > 0) {
    analyticsData.pricePromise.priceMessageType = 'matched';
    analyticsData.pricePromise.priceTableData = competitorsTable.map((competitor) => {
      if (!competitor || !competitor.competitorId || !competitor.price) {
        return 'undefined:undefined';
      }
      return `${competitor.competitorId}:${competitor.price}`;
    }).join('|');
    analyticsData.pricePromise.isCurryesCheapest =
      [20, 30].indexOf(competitorsTable[0].competitorId) > -1;
  }
  dataLayerUtils.satelliteTrack('pricePromiseOnload');
}

export default pricePromiseAnalytics;
